import { getApi } from './_apihelper';

export const GetQuestionsAnswers = (obj) =>
  getApi(
    `${process.env.REACT_APP_JOB_POSTINGS}/job/${obj.job_id}/applicant/${obj.applicant_id}/answers`,
    process.env.REACT_APP_JOBOPENING
  );
